import { useBalanceDecrease } from "../../hooks/useBalanceDecrease";
import { DeductionPulse } from "../DeductionPulse";

import { useValueFormatter } from "@/utils/useValueFormatter";

export function useTilePulse(value: number) {
  const { format } = useValueFormatter();
  const decrease = useBalanceDecrease(value);
  return <DeductionPulse decrease={decrease} format={(tokens) => format(tokens, "decimal")} className="rounded-lg" />;
}